import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';
import { Box, Typography, useTheme } from '@mui/material';

const MinutesActionsGeneralInfoPlayerComponent = ({ partidos }) => {
    const theme = useTheme();
    const totalJornadas = partidos?.length ?? 0;
    // Contadores de titular, suplente y no jugados
    const titularidad = partidos.filter((p) => !p.substitute && Number(p.minutes ?? 0) > 0).length ?? 0;
    const suplencias = partidos.filter((p) => p.substitute).length ?? 0;
    const noJugados = totalJornadas - (titularidad + suplencias) ?? 0;

    // Calcular porcentajes
    const titularidadPorcentaje =
        totalJornadas > 0 ? ((titularidad / totalJornadas) * 100).toFixed(1) : '0.0';
    const suplenciasPorcentaje = totalJornadas > 0 ? ((suplencias / totalJornadas) * 100).toFixed(1) : '0.0';
    const noJugadosPorcentaje = totalJornadas > 0 ? ((noJugados / totalJornadas) * 100).toFixed(1) : '0.0';

    const rojo = '#D32F2F';
    const naranja = '#F57C00';
    const verde = '#388E3C';
    const azul = '#1976D2';

    const stats = [
        {
            label: 'Titularidades',
            value: `${titularidad}/${totalJornadas}`,
            porcentaje: `${titularidadPorcentaje}%`,
        },
        {
            label: 'Suplencias',
            value: `${suplencias}/${totalJornadas}`,
            porcentaje: `${suplenciasPorcentaje}%`,
        },
        {
            label: 'No jugados',
            value: `${noJugados}/${totalJornadas}`,
            porcentaje: `${noJugadosPorcentaje}%`,
        },
    ];

    const getColor = (label) => {
        if (label === 'Titularidades' || label === 'Suplencias') {
            const porcentaje = parseFloat(titularidadPorcentaje);
            if (porcentaje > 80)
                return azul; // Azul (Excelente)
            else if (porcentaje > 60)
                return verde; // Verde (Bueno)
            else if (porcentaje > 40)
                return naranja; // Naranja (Regular)
            else return rojo; // Rojo (Muy malo)
        }

        // Suplencias heredan el mismo color de Titularidades
        if (label === 'No jugados') {
            // No jugados (más alto es peor, colores invertidos)
            const porcentaje = parseFloat(noJugadosPorcentaje);
            if (porcentaje > 60) return rojo; // Rojo (Muy malo)
            if (porcentaje > 40) return naranja; // Naranja (Regular)
            if (porcentaje > 20) return verde; // Verde (Bueno)
            return azul; // Azul (Excelente)
        }

        return rojo; // Color por defecto
    };

    return (
        <CustomSectionWrapper color="accent" title="Titularidades y suplencias de la temporada">
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {stats.map((item, index) => (
                    <Box
                        key={index}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '32.66666%',
                            borderLeft: index === 0 ? 'none' : `1px solid ${theme.palette.border.main}`,
                        }}
                    >
                        <Typography fontWeight="bold">{item.label}</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography sx={{ fontSize: '14px' }} variant="h3">
                                {item.value}
                            </Typography>
                            <Typography
                                sx={{
                                    backgroundColor: getColor(item.label),
                                    color: '#fff',
                                    padding: '2px 4px',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                }}
                            >
                                {item.porcentaje}
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Box>
        </CustomSectionWrapper>
    );
};

export default MinutesActionsGeneralInfoPlayerComponent;
